<template>
  <div class="campaign-list">
    <v-list
      v-for="(campaign, index) in listActiveCampaigns"
      :key="index"
      dense
      class="py-0"
    >
      <v-card outlined>
        <v-list-group
          v-model="campaign.expand"
          class="py-0 my-0"
          color=""
          append-icon=""
          :ripple="false"
        >
          <template v-slot:prependIcon>
            <div>
              <v-icon>
                {{ campaign.expand ? "mdi-chevron-up" : "mdi-chevron-down" }}
              </v-icon>
            </div>
          </template>
          <template v-slot:activator>
            <v-list-item-title class="my-4">
              <!-- DESKTOP -->
              <div
                v-if="$vuetify.breakpoint.mdAndUp"
                class="d-flex align-center justify-space-between"
              >
                <!-- Title and Qty Games -->
                <div class="mt-1 text-truncate" style="width: calc(25% - 14px)">
                  <div class="d-flex flex-column" style="gap: 6px">
                    <div>
                      {{
                        campaign.title.length > 24 &&
                        $vuetify.breakpoint.smAndDown
                          ? campaign.title.toUpperCase().substr(0, 24)
                          : campaign.title.toUpperCase()
                      }}
                    </div>

                    <div style="color: #a3a3a3">
                      {{ $tc("gamesSingularPlural", campaign.games.length) }}
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-column" style="width: calc(50% - 28px)">
                  <div class="d-flex justify-space-between" style="width: 100%">
                    <div style="width: 50%">
                      <div class="d-flex flex-column mb-6" style="gap: 8px">
                        <div>
                          {{ $t("newCasino.freespins.claimDate") }}
                        </div>
                        <div>
                          {{
                            handleExpirationDate(campaign.claimed_date) ||
                              "00/00/00"
                          }}
                        </div>
                      </div>

                      <!-- Qty freespins -->
                      <div>
                        <div class="mb-2">
                          {{ $t("newCasino.freespins.roundsQuantity") }}
                        </div>
                        <div>{{ campaign.quantity }}</div>
                      </div>
                    </div>

                    <div style="width: 50%">
                      <div class="d-flex flex-column mb-6" style="gap: 8px">
                        <div>{{ $t("dateExpiration") }}</div>
                        <div>
                          {{ handleExpirationDate(campaign.expiration_date) }}
                        </div>
                      </div>

                      <div v-if="historic">
                        <div class="mb-2">{{ $t("balance") }}</div>
                        <div>
                          {{ `${$t("labelCurrency")} ${campaign.win_amount}` }}
                        </div>
                      </div>
                      <!-- (TAB ACTIVES PROMOS/CAMPAIGNS) -->
                      <div v-else-if="campaign.expiresIn" style="width: 100%">
                        <div class="mb-4">
                          {{ campaign.expiresIn.text }}
                        </div>
                        <v-progress-linear
                          min="1"
                          max="100"
                          color="primary"
                          :value="
                            progressBar(
                              campaign.expiration_date,
                              campaign.claimed_date
                            )
                          "
                        ></v-progress-linear>
                      </div>
                    </div>
                  </div>

                  <!-- Progress bar Expires campaign (TAB HISTORIC) -->
                  <div
                    v-if="historic"
                    class="d-flex flex-column align-center"
                    style="width: 100%"
                  >
                    <div v-if="campaign.status == 4">
                      <v-chip class="red lighten-1 mt-6 mb-2" small>
                        {{ $t("canceledCampaign") }}
                      </v-chip>

                      <v-tooltip top content-class="tooltip">
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            class="ml-2 mt-6 mb-2"
                            color="info"
                            small
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                        <span>
                          {{ $t("tooltipCanceledCampaign") }}
                        </span>
                      </v-tooltip>
                    </div>
                    <v-chip v-else small class="purple darken-2 mt-6 mb-2">
                      {{ $t("expiredCampaign") }}
                    </v-chip>
                    <v-progress-linear
                      min="1"
                      max="100"
                      color="primary"
                      value="100"
                    ></v-progress-linear>
                  </div>
                </div>

                <!-- Image Promo/Campaign-->
                <div
                  class="d-flex flex-column align-end"
                  style="width: calc(25% - 14px); gap: 16px;"
                >
                  <v-icon v-if="showIcon.includes(campaign.id)" x-large>
                    mdi-image
                  </v-icon>
                  <img
                    v-else
                    :src="campaign.image"
                    @error="
                      imageError({
                        src: campaign.image,
                        code: campaign.codigo,
                      })
                    "
                    style="border-radius: 4px; max-width: 150px;"
                  />

                  <FreespinDetailDialog
                    rules
                    :title="campaign.title"
                    :description="campaign.description"
                    :activeCampaigns="true"
                    :campaignGames="campaign.games"
                  />
                </div>
              </div>
              <!-- MOBILE -->
              <div v-else class="d-flex justify-space-between align-center">
                <div
                  class="mt-1 text-truncate"
                  :style="`min-width: ${getMinWidth};`"
                >
                  <!-- Title and Qty Games -->
                  <div class="d-flex flex-column" style="gap: 6px">
                    <div>
                      {{
                        campaign.title.length > 24 &&
                        $vuetify.breakpoint.smAndDown
                          ? campaign.title.toUpperCase().substr(0, 24)
                          : campaign.title.toUpperCase()
                      }}
                    </div>

                    <div style="color: #a3a3a3">
                      {{ $tc("gamesSingularPlural", campaign.games.length) }}
                    </div>
                  </div>
                </div>

                <!-- Imagem da campanha na "capa" do list group (mobile) -->
                <div class="d-flex align-center">
                  <v-icon v-if="showIcon.includes(campaign.id)" x-large>
                    mdi-image
                  </v-icon>
                  <img
                    v-else
                    :src="campaign.image"
                    @error="
                      imageError({
                        src: campaign.image,
                        code: campaign.codigo,
                      })
                    "
                    style="border-radius: 4px; max-width: 100px;"
                  />
                </div>
              </div>
            </v-list-item-title>
          </template>
          <template v-slot:default>
            <!-- Mobile -->
            <div v-if="!$vuetify.breakpoint.mdAndUp">
              <v-divider />
              <v-list-item class="px-0">
                <v-list-item-content class="d-flex caption">
                  <div class="px-4 py-4 d-flex flex-column" style="gap: 24px">
                    <div>
                      <div
                        class="
                          d-flex
                          align-center
                          justify-space-between
                        "
                        style="gap: 16px;"
                      >
                        <div style="width: 50%">
                          <div class="mb-2">
                            {{ $t("newCasino.freespins.claimDate") }}
                          </div>
                          <div>
                            {{ handleExpirationDate(campaign.claimed_date) }}
                          </div>
                        </div>
                        <div style="width: 50%">
                          <div class="mb-2">
                            {{ $t("dateExpiration") }}
                          </div>
                          <div>
                            {{ handleExpirationDate(campaign.expiration_date) }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-column align-center">
                      <div
                        v-if="
                          historic ||
                            progressBar(
                              campaign.expiration_date,
                              campaign.claimed_date
                            ) >= 100
                        "
                      >
                        <div v-if="campaign.status == 4">
                          <v-chip class="red lighten-1 mt-6 mb-2" small>
                            {{ $t("canceledCampaign") }}
                          </v-chip>

                          <v-tooltip top content-class="tooltip">
                            <template v-slot:activator="{ on }">
                              <v-icon
                                v-on="on"
                                class="ml-2 mt-6 mb-2"
                                color="info"
                                small
                              >
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>
                              {{ $t("tooltipCanceledCampaign") }}
                            </span>
                          </v-tooltip>
                        </div>
                        <v-chip v-else small class="purple darken-2 mb-1">
                          {{ $t("expiredCampaign") }}
                        </v-chip>
                      </div>
                      <div v-else-if="campaign.expiresIn" class="mb-2">
                        {{ campaign.expiresIn.text }}
                      </div>
                      <v-progress-linear
                        min="1"
                        max="100"
                        color="primary"
                        :value="
                          historic
                            ? 100
                            : progressBar(
                                campaign.expiration_date,
                                campaign.claimed_date
                              )
                        "
                      ></v-progress-linear>
                    </div>
                  </div>
                  <v-divider />
                  <div class="d-flex align-top pa-4" style="gap: 16px">
                    <div class="d-flex flex-column" style="flex: 1;">
                      <div class="d-flex mb-2">
                        {{ $t("newCasino.freespins.roundsQuantity") }}
                      </div>
                      <div>
                        {{ campaign.quantity }}
                      </div>

                      <FreespinDetailDialog
                        list
                        marginTop
                        rules
                        :title="campaign.title"
                        :description="campaign.description"
                        :campaignGames="campaign.games"
                      />
                    </div>

                    <div class="d-flex flex-column" style="flex: 1;">
                      <div
                        class="d-flex mb-2"
                        :style="historic ? 'opacity: 1' : 'opacity: 0'"
                      >
                        {{ $t("balance") }}
                      </div>
                      <div :style="historic ? 'opacity: 1' : 'opacity: 0'">
                        {{ `${$t("labelCurrency")} ${campaign.win_amount}` }}
                      </div>

                      <DialogPlayGamesMobile
                        :campaign="campaign"
                        :loading="
                          (campaign) =>
                            loadingDialogPlayGamesMobile(campaign, index)
                        "
                        :disabled="disableDialogPlayGamesMobile"
                      />
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
            </div>
            <!-- Desktop -->
            <div v-else>
              <v-divider />
              <div v-for="(game, index) in campaign.games" :key="index">
                <div
                  class="d-flex justify-space-between pa-4"
                  style="width: 100%;"
                >
                  <div
                    class="d-flex justify-space-between align-center"
                    style="width: 100%;"
                  >
                    <!-- list image -->
                    <div
                      style="min-width: 18%; gap: 16px;"
                      class="d-flex align-center"
                    >
                      <v-icon
                        v-if="showIcon.includes(game.game_id)"
                        left
                        size="80"
                      >
                        mdi-image
                      </v-icon>

                      <img
                        v-else
                        :src="
                          encodeURI(
                            `https://cdn.softswiss.net/i/s3/${
                              campaign.games[index].game_identifier.split(
                                ':'
                              )[0]
                            }/${
                              campaign.games[index].game_identifier.split(
                                ':'
                              )[1]
                            }.png`.replace(/\s/g, '')
                          )
                        "
                        @error="imgError(game.game_id)"
                        style="border-radius: 4px; max-width: 80px;"
                      />

                      <div class="body-2">
                        {{ game.game_name }}
                      </div>
                    </div>
                    <!-- play btn -->
                    <div class="caption" style="gap: 16px">
                      <v-btn
                        color="primary"
                        small
                        :loading="
                          openingGameDialog === campaign.games[index].game_id &&
                            openingGameCampaign === campaign.id
                        "
                        :disabled="openingGameDialog !== 0 || historic"
                        @click.stop="
                          cardClick(campaign.games[index], campaign.id)
                        "
                        style="border-radius: 8px; padding: 0 3rem;"
                      >
                        {{ $t("play") }}
                      </v-btn>
                    </div>
                  </div>
                </div>
                <v-divider
                  v-if="index < campaign.games.length - 1 && !historic"
                  :key="index"
                ></v-divider>
              </div>
            </div>
          </template>
        </v-list-group>
      </v-card>
    </v-list>

    <ItemDialog
      :dialog="itemDialog"
      type="lobby"
      :categoryName="currentGameDialog ? currentGameDialog.categoryName : ''"
      :item="currentGameDialog"
      @closeItemDialog="closeItemDialog"
    />
  </div>
</template>
<script>
import FreespinDetailDialog from "./FreespinDetailDialog.vue";
import ItemDialog from "@/views/home/casinoNew/components/item/itemDialog.vue";
import DialogPlayGamesMobile from "./DialogPlayGamesMobile.vue";

export default {
  props: ["activeCampaigns", "historic"],

  components: {
    FreespinDetailDialog,
    ItemDialog,
    DialogPlayGamesMobile,
  },

  data: () => ({
    currentIndex: -1,
    firstItem: {
      infirstItem: false,
      //firstItemObj
    },
    showIcon: [],
    gamesDialogsOpened: [],
    openingGameDialog: 0,
    itemDialog: false,
    currentGameDialog: {},
    listActiveCampaigns: [],
    possibleExtensions: ["png", "jpg", "jpeg", "webp"],
  }),

  mounted() {
    this.listActiveCampaigns = this.activeCampaigns;
  },

  computed: {
    isXsmall() {
      return this.$vuetify.breakpoint.name == "xs";
    },

    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },

    loadingDialogPlayGamesMobile(campaign, index) {
      return (
        this.openingGameDialog === campaign.games[index].game_id &&
        this.openingGameCampaign === campaign.id
      );
    },

    disableDialogPlayGamesMobile() {
      return this.openingGameDialog !== 0 || this.historic;
    },
    bonusBalance() {
      return this.$store.state.cashBonus.status == "1" &&
        this.$store.state.cashBonus.value > 0
        ? this.$store.state.cashBonus.value
        : 0;
    },

    getMinWidth() {
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint == "md") {
        return "20%";
      } else if (breakpoint == "lg") {
        return "30%";
      } else if (breakpoint == "xl") {
        return "20%";
      }

      return "";
    },

    allCasinoGames() {
      return this.$store.state.casinoGames;
    },
  },

  methods: {
    progressBar(endDate, claimDate) {
      var countDownDate = new Date(endDate).getTime();
      var startDate = new Date(claimDate).getTime();
      var now = new Date().getTime();
      var distanceWhole = countDownDate - startDate;
      var distanceLeft = countDownDate - now;
      var minutesLeft = Math.floor(distanceLeft / (1000 * 60));
      var minutesTotal = Math.floor(distanceWhole / (1000 * 60));
      var progress = Math.floor(
        ((minutesTotal - minutesLeft) / minutesTotal) * 100
      );
      return progress;
    },
    cardClick(game, campaignId) {
      if (this.openingGameDialog !== 0) {
        return;
      }

      const gameId = game.game_id;

      const gameAlreadyOpened = this.gamesDialogsOpened.find(
        (game) => game.game_id === gameId
      );

      if (gameAlreadyOpened) {
        this.currentGameDialog = gameAlreadyOpened;
        this.itemDialog = true;
        return;
      }

      this.openingGameDialog = gameId;
      this.openingGameCampaign = campaignId;

      this.$request
        .post("/player/online/casino/game", { game_id: gameId, status: "1" })
        .then((res) => {
          const game = res.data.dados;

          game.game_id = gameId;
          game.src = encodeURI(
            `https://cdn.softswiss.net/i/s3/${
              game.identifier_game.split(":")[0]
            }/${game.identifier_game.split(":")[1]}.png`.replace(/\s/g, "")
          );
          game.categories = game.categories.split(",");
          game.categoryName = game.categories[0];
          game.providerImage = encodeURI(
            `https://cdn.softswiss.net/logos/providers/white/${
              game.identifier_game.split(":")[0]
            }.svg`.replace(/\s/g, "")
          );
          game.key = `${gameId}-${game.id_provider}`;

          this.gamesDialogsOpened.push(game);
          this.currentGameDialog = game;
          this.itemDialog = true;
        })
        .finally(() => {
          this.openingGameDialog = 0;
        });
    },

    imageError({ src, code }) {
      let currExtension = src.split(".")[src.split(".").length - 1];
      let currExtensionIndex = this.possibleExtensions.indexOf(currExtension);
      let nextExtensionIndex = currExtensionIndex + 1;

      let currentCampaignImageErrorIndex = 0;
      const currentCampaignImageError = this.listActiveCampaigns.find(
        (campaign, index) => {
          currentCampaignImageErrorIndex = index;
          return campaign.codigo == code;
        }
      );

      if (nextExtensionIndex == this.possibleExtensions.length) {
        this.showIcon.push(currentCampaignImageError.id);
        currentCampaignImageErrorIndex = 0;

        return;
      }

      let nextExtension = this.possibleExtensions[nextExtensionIndex];

      this.listActiveCampaigns[
        currentCampaignImageErrorIndex
      ].image = encodeURI(
        `https://dozr8la71aog.cloudfront.net/domains/${this.$domain()}/promotions/${code}.${nextExtension}`
      );
      currentCampaignImageErrorIndex = 0;
    },

    closeItemDialog() {
      this.currentGameDialog = {};
      this.itemDialog = false;
    },

    handleExpirationDate(expirationDate) {
      if (!expirationDate) {
        return "";
      }
      return new Date(expirationDate.replace(" ", "T"))
        .toLocaleDateString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
        .toLowerCase();
    },

    getColorByStatus(status) {
      const colors = {
        0: { text: this.$t("inactive"), color: "blue-grey" },
        1: { text: this.$t("active"), color: "green" },
        2: { text: this.$t("finishedcampaign"), color: "grey darken-4" },
        3: { text: this.$t("canceled"), color: "purple darken-2" },
        4: { text: this.$t("expired"), color: "warning" },
      };

      return colors[status];
    },
  },
};
</script>
<style scoped>
.campaign-list .v-list-item__icon {
  display: flex;
  align-self: center;
}
.tooltip {
  width: 260px !important;
  padding: 8px 16px;
}
</style>
